const AdmissionsPage = () => {
  return <div className="container admissions-page padding-top">Admissions Page</div>;
};

export default AdmissionsPage;
